import styled, { css } from 'styled-components';
import { buttonResetStyleIncludingFocus } from '../../../commonStyles/buttonReset';
import colors from '../../../helpers/colors';
import fonts from '../../../helpers/fonts';
import mediaQuery from '../../../helpers/mediaQuery';
import spacing from '../../../helpers/spacing';
import Icon from '../../Icon';
import Link from '../../Link';
import LogoLink from '../../LogoLink';
import { burgerEventStyles } from './BurgerMenuIcon/styles';
import { baseSectionItemStyles, eventStyles } from './Menus/styles';

const hideOnDesktop = mediaQuery.tabletLandscape`
  display: none;
`;

export const MenuButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  ${hideOnDesktop}
`;

export const MenuButton = styled.button`
  /* On IE, "justify-content: spacing-between" doesn't work as intended with absolutely positioned elements -
     it still considers them part of the flexbox. So we order this later than the other elements
     to position this button to the right when the menu is open */
  order: 1;

  ${buttonResetStyleIncludingFocus}

  display: flex;
  justify-content: flex-end;
  align-items: center;

  ${fonts.headingXSmall}
  & {
    font-weight: lighter;
    color: ${colors.neutral08};
  }

  margin: auto ${spacing(-1)};
  padding: ${spacing(1)};

  & > *:not(:last-child) {
    margin-right: ${spacing(1.5)};
  }

  &:focus-visible,
  &:active {
    border-radius: 8px;
    border: 2px solid ${colors.neutral08};
  }

  ${burgerEventStyles}
  ${hideOnDesktop}
`;

export const StyledPhoneIconLink = styled(LogoLink)`
  && {
    margin-right: ${spacing(2)};
  }

  img {
    padding: 0 ${spacing(0.75)};
  }
`;

export const IconWithMargin = styled(Icon)`
  margin-right: ${spacing(1)};
`;

export const MenuContainer = styled.div`
  width: 100%;
  max-height: calc(92.5vh - 100%);

  @supports (max-height: 100dvh) {
    max-height: calc(100dvh - 100%);
  }

  overflow-y: auto;

  /* Position below the main header */
  position: absolute;
  top: 100%;
  left: 0;

  ${hideOnDesktop}
`;

const TertiaryStyling = css`
  ${buttonResetStyleIncludingFocus}

  ${fonts.headingSmall}

  ${baseSectionItemStyles}

  border-top: solid 1px ${colors.neutral06};
`;

export const TertiaryNavItemHeading = styled(Link)`
  ${TertiaryStyling};
  && {
    color: ${colors.neutral08};
  }

  & {
    font-weight: lighter;
  }

  transition: background-color 0.3s ease-out;
  background-color: ${colors.core02};

  ${eventStyles(colors.neutral08)}

  &:hover {
    color: ${colors.neutral08};
  }
  &:focus-visible {
    color: ${colors.neutral08};
  }
  &:active {
    color: ${colors.neutral08};
  }
`;

export const TertiaryNavItemDark = styled(Link)`
  ${TertiaryStyling};
  && {
    color: ${colors.neutral08};
  }

  transition: background-color 0.3s ease-out;
  background-color: ${colors.core02};

  ${eventStyles(colors.neutral08)}

  &:hover {
    color: ${colors.neutral08};
  }
  &:focus-visible {
    color: ${colors.neutral08};
  }
  &:active {
    color: ${colors.neutral08};
  }
`;

export const PrimaryNavLinkLight = styled(Link)`
  ${TertiaryStyling};
  && {
    color: ${colors.core02};
  }

  transition: background-color 0.3s ease-out;
  background-color: ${colors.neutral08};

  ${eventStyles(colors.core02)}

  &:hover {
    color: ${colors.core02};
  }
  &:focus-visible {
    color: ${colors.core02};
  }
  &:active {
    color: ${colors.core02};
  }
`;

export const TertiaryNavIconBackground = styled.div`
  height: 2.5rem;
  width: 2.5rem;
  border-radius: 50%;
  margin-right: ${spacing(2)};

  background-color: ${colors.core03};

  /* Centre the icon */
  display: flex;
  justify-content: center;
  align-items: center;
`;
